// @ts-nocheck

"use client"

import Image from "next/image"
import Link from "next/link"
import React from "react"
import "./styles.scss"

const Footer = () => {
    return (
        <footer className="flex flex-col gap-1 justify-center items-center w-full relative">
            <div className="absolute z-[10] w-full">
                <div className="flex flex-col lg:flex-row gap-5 justify-between items-start w-full">
                    <div className="flex flex-col gap-5 justify-center items-center w-full lg:w-1/4 translate-y-[-2rem]">
                        <div className="relative w-[118px] h-[118px]">
                            <Image
                                src="/images/beluxe/full-name_logo-vertical.svg"
                                alt="BeLuxe Logo"
                                layout="fill"
                                objectFit="contain"
                                loading="lazy"
                                lang="pl"
                                quality={100}
                            />
                        </div>
                        <div className="flex flex-row gap-3 justify-center items-center w-full">
                            <Image
                                src="/images/beluxe/phone-call__icon.svg"
                                alt="Phone call"
                                layout="intrinsic"
                                width={18}
                                height={18}
                                quality={100}
                            />
                            <span className="text-[14px] font-medium leading-[15px] text-white font-['Comfortaa'] w-fit">+34 672 311 136</span>
                        </div>
                        <div className="flex flex-row gap-3 justify-center items-center w-full">
                            <Image
                                src="/images/beluxe/phone-call__icon.svg"
                                alt="Phone call"
                                layout="intrinsic"
                                width={18}
                                height={18}
                                quality={100}
                            />
                            <span className="text-[14px] font-medium leading-[15px] text-white font-['Comfortaa'] w-fit">+34 687 111 426</span>
                        </div>
                        <div className="flex flex-row gap-3 justify-center items-center w-full">
                            <Image
                                src="/images/beluxe/email-attachment__icon.svg"
                                alt="Phone call"
                                layout="intrinsic"
                                width={18}
                                height={18}
                                quality={100}
                            />
                            <span className="text-[14px] font-medium leading-[15px] text-white font-['Comfortaa'] w-fit">INFO@BELUXEPROPERTIES.COM</span>
                        </div>
                    </div>
                    <div className="flex flex-col gap-5 justify-start items-center w-full lg:w-1/4">
                        <h5 className="text-[16px] font-['Didot'] font-bold text-center uppercase w-full text-[#EBD29F] mb-5">Explore</h5>
                        <Link href="/about" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            ABOUT US
                        </Link>
                        <Link href="/contact" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            CONTACT
                        </Link>
                        <Link href="/properties" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            PROPERTIES
                        </Link>
                        <Link href="/guides" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            GUIDES
                        </Link>
                    </div>
                    <div className="flex flex-col gap-5 justify-start items-center w-full lg:w-1/4">
                        <h5 className="text-[16px] font-['Didot'] font-bold text-center uppercase w-full text-[#EBD29F] mb-5">LEGAL NOTICES</h5>
                        <Link href="/privacy-policy" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            PRIVACY POLICY
                        </Link>
                        <Link href="/cookies-policy" className="text-[14px] font-medium text-center uppercase w-full text-white leading-[15px] tracking-[0.125rem] font-['Comfortaa']">
                            COOKIES POLICY
                        </Link>
                    </div>
                    <div className="flex flex-col gap-1 justify-center items-center w-full lg:w-1/4">
                        <h5 className="text-[16px] font-['Didot'] font-bold text-center uppercase w-full text-[#EBD29F] mb-5">FOLLOW US</h5>
                        <div className="flex flex-row flex-wrap gap-5 justify-center lg:justify-end items-center w-full lg:w-[80px]">
                            {[{
                                icon: "/images/beluxe/icon-instagram__golden.svg",
                                link: "https://instagram.com/beluxeproperties?igshid=c3h1NDgxbGdxYnA%3D&utm_source=qr",
                                title: "Instagram"
                            }, {
                                icon: "/images/beluxe/icon-facebook__golden.svg",
                                link: "https://www.facebook.com/profile.php?id=61551720903909",
                                title: "Facebook"
                            }, {
                                icon: "/images/beluxe/icon-youtube__golden.svg",
                                link: "https://youtube.com/@BeLuxeProperties?si=3UJu-sww7St3jmM_",
                                title: "YouTube"
                            }].map((social, index) =>
                                <Link href={social.link} hrefLang="en" target="_blank" key={index} className="relative w-[30px] h-[30px]">
                                    <Image
                                        src={social.icon || "/images/"}
                                        alt={social.title || " "}
                                        layout="intrinsic"
                                        width={30}
                                        height={30}
                                        lang="pl"
                                        loading="eager"
                                        quality={100}
                                    />
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="absolute w-full h-fit lg:h-[60px] bottom-0 z-[10] border-t-[#EBD29F] border-t-[0.5px] px-5 lg:px-[50px] py-3 lg:py-0 flex flex-col lg:flex-row gap-1 justify-between items-center">
                <div className="flex flex-row gap-1 justify-center lg:justify-start text-center lg:text-left items-center w-full lg:w-1/2 font-['Comfortaa'] text-white text-[12px] font-medium tracking-[0.1rem] leading-[14px]">
                    Copyright 2025 © All Right Reserved BeLuxe
                </div>
                <div className="flex flex-row gap-1 justify-center lg:justify-end text-center lg:text-right items-center w-full lg:w-1/2 font-['Comfortaa'] text-white text-[12px] font-medium tracking-[0.1rem] leading-[14px]">
                    Designed and built by profabrica.eu
                </div>
            </div>
            <div className="relative w-full h-[990px] lg:h-[439px] z-[1]">
                <Image
                    src="/images/beluxe/photo_palms__.webp"
                    alt="Photo palms"
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    lang="pl"
                    loading="lazy"
                    quality={100}
                />
            </div>
        </footer>
    )
}

export default Footer
